import { Dialog, Box} from '@mui/material';
import KeywordInput from '../Data Quality/KeywordInput';
import { TriangleAlert } from 'lucide-react';


const ConfigPopup = ({configForm,configModalOpen,closeConfigModal,handleConfigChange,formErrors,handleConfigSave,disableAllFields,assetNameCheckMessage,assetNameIsUnique,allFieldsValid,formTouched,regionsCountriesData,setConfigForm,isEditingExistingConfig}) => {
      const isAtRest = configForm.dataAssetJobType === 'at_rest';
      const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      const toMonthNumber = (monthName) => MONTHS.indexOf(monthName) + 1;
      const toMonthName = (num) => MONTHS[num - 1];
    return (
        <>
        <Dialog open={configModalOpen} onClose={closeConfigModal} maxWidth="lg" fullWidth>
              <Box p={3}>
                <div className="text-lg font-bold mb-4">Configure Asset</div>
                <form>
                {/* Asset Information Section */}
                <div className="mb-6 bg-blue-50 rounded-lg p-4 border border-blue-200">
                  <h3 className="text-lg font-semibold text-blue-800 mb-4 flex items-center">
                    <div className="w-[5px] h-6 bg-blue-500 rounded mr-3"></div>
                    Asset Information
                  </h3>
                  <div className="grid [grid-template-columns:1fr_1fr] gap-4 p-2">
                    <div className="mb-3">
                      <label>Asset Name <span className="text-red-500">*</span></label>
                      <input 
                        name="assetName" 
                        value={configForm.assetName} 
                        onChange={handleConfigChange} 
                        placeholder="Enter Asset Name"
                        className="w-full border rounded p-2 bg-gray-100" 
                        readOnly={isEditingExistingConfig}
                        disabled={isEditingExistingConfig}
                      />
                      {formTouched && formErrors.assetName && <div className="text-red-500 text-xs">{formErrors.assetName}</div>}
                      {assetNameCheckMessage && !isEditingExistingConfig && (
                        <div className={`text-xs mt-1 ${assetNameIsUnique === false ? 'text-red-500' : assetNameIsUnique === true ? 'text-green-600' : ''}`}>{assetNameCheckMessage}</div>
                      )}
                      {isEditingExistingConfig && (
                        <div className="text-xs mt-1 text-gray-600">Asset name cannot be changed once configured</div>
                      )}
                    </div>

                    <div className="mb-3">
                      <label>Dataframe Name <span className="text-red-500">*</span></label>
                      <input 
                        name="dataframeName" 
                        value={configForm.dataframeName} 
                        onChange={handleConfigChange} 
                        placeholder="Enter data frame name"
                        className="w-full border rounded p-2" 
                        disabled={disableAllFields} 
                      />
                      {formTouched && formErrors.dataframeName && <div className="text-red-500 text-xs">{formErrors.dataframeName}</div>}
                    </div>

                    
                   
                    
                    <div className="mb-3">
                      <label>Data Asset Owner <span className="text-red-500">*</span></label>
                      <input 
                        type="email"
                        name="dataAssetOwner" 
                        value={configForm.dataAssetOwner} 
                        onChange={handleConfigChange} 
                        placeholder="Enter Email Address (@effem.com)"
                        className="w-full border rounded p-2" 
                        disabled={disableAllFields} 
                      />
                      {formTouched && formErrors.dataAssetOwner && <div className="text-red-500 text-xs">{formErrors.dataAssetOwner}</div>}
                      {!formTouched && configForm.dataAssetOwner && (() => {
                        const ALLOWED_EMAIL_DOMAINS = ['effem.com'];
                        const emailPattern = /^[^\s@]+@([^\s@]+)$/;
                        const match = configForm.dataAssetOwner.match(emailPattern);
                        const isValid = match && ALLOWED_EMAIL_DOMAINS.includes(match[1]);
                        return !isValid && <div className="text-red-500 text-xs">Email must be from: effem.com</div>;
                      })()}
                    </div>

                    <div className="mb-3">
                      <label>Technical Data Steward <span className="text-red-500">*</span></label>
                      <input 
                        type='email' 
                        name="technicalDataSteward" 
                        value={configForm.technicalDataSteward} 
                        onChange={handleConfigChange} 
                        placeholder="Enter Email Address (@effem.com)"
                        className="w-full border rounded p-2" 
                        disabled={disableAllFields} 
                      />
                      {formTouched && formErrors.technicalDataSteward && <div className="text-red-500 text-xs">{formErrors.technicalDataSteward}</div>}
                      {!formTouched && configForm.technicalDataSteward && (() => {
                        const ALLOWED_EMAIL_DOMAINS = ['effem.com'];
                        const emailPattern = /^[^\s@]+@([^\s@]+)$/;
                        const match = configForm.technicalDataSteward.match(emailPattern);
                        const isValid = match && ALLOWED_EMAIL_DOMAINS.includes(match[1]);
                        return !isValid && <div className="text-red-500 text-xs">Email must be from: effem.com</div>;
                      })()}
                    </div>
                    <div className="mb-3">
                      <label>Region <span className="text-red-500">*</span></label>
                      <input 
                        name="region" 
                        value={configForm.region} 
                        onChange={handleConfigChange} 
                        placeholder="Enter Region"
                        className="w-full border rounded p-2 bg-gray-100" 
                        readOnly 
                        disabled={disableAllFields} 
                      />
                      {formTouched && formErrors.region && <div className="text-red-500 text-xs">{formErrors.region}</div>}
                    </div>
                    <div className="mb-3">
                      <label>Market <span className="text-red-500">*</span></label>
                      <input 
                        name="market" 
                        value={configForm.market} 
                        onChange={handleConfigChange} 
                        placeholder="Enter Market"
                        className="w-full border rounded p-2 bg-gray-100" 
                        readOnly 
                        disabled={disableAllFields} 
                      />
                      {formTouched && formErrors.market && <div className="text-red-500 text-xs">{formErrors.market}</div>}
                    </div>
                    <div className="mb-3">
                      <label>Asset Description <span className="text-red-500">*</span></label>
                      <div>
                        <textarea 
                          name="assetDescription" 
                          value={configForm.assetDescription} 
                          onChange={(e) => {
                            const value = e.target.value;
                            const maxLength = 10000;
                            if (value.length <= maxLength) {
                              handleConfigChange(e);
                            }
                          }}
                          placeholder="Enter detailed description of the asset"
                          className={`w-full border rounded p-2 resize-none ${
                            configForm.assetDescription?.length > 10000 
                              ? 'border-red-500 focus:ring-red-500 focus:border-red-500' 
                              : configForm.assetDescription?.length > 9000 
                                ? 'border-orange-400 focus:ring-orange-400 focus:border-orange-400' 
                                : 'border-gray-300 focus:ring-[#bb1ccc] focus:border-[#bb1ccc]'
                          }`}
                          rows={3}
                          maxLength={10000}
                          disabled={disableAllFields} 
                        />
                        <div className="mt-1 flex justify-between items-center">
                          <span className={`text-sm font-medium ${
                            configForm.assetDescription?.length > 10000 
                              ? 'text-red-600' 
                              : configForm.assetDescription?.length > 9000 
                                ? 'text-orange-600' 
                                : 'text-gray-500'
                          }`}>
                            {configForm.assetDescription?.length || 0}/10000 characters
                          </span>
                          {configForm.assetDescription?.length > 10000 && (
                            <span className="text-sm text-red-600 font-semibold bg-red-50 px-2 py-1 rounded">
                              ⚠️ You can't enter more than 10000 characters
                            </span>
                          )}
                          {configForm.assetDescription?.length > 9000 && configForm.assetDescription?.length <= 10000 && (
                            <span className="text-sm text-orange-600 font-medium">
                              ⚠️ Approaching character limit
                            </span>
                          )}
                        </div>
                      </div>
                      {formTouched && formErrors.assetDescription && <div className="text-red-500 text-xs">{formErrors.assetDescription}</div>}
                    </div>
                   
                    <div className="mb-3">
                      <label>Asset Tags </label>
                       <KeywordInput
                                    field={{name: "tags", placeholder: "Add a tag and press Enter or click Add", required: false}}
                                    formData={configForm}
                                    setFormData={setConfigForm}
                                    />
                    </div>
                  </div>
                </div>

                {/* Schedule Information Section */}
                <div className="mb-6 bg-purple-50 rounded-lg p-4 border border-purple-200">
                  <h3 className="text-lg font-semibold text-purple-800 mb-4 flex items-center">
                    <div className="w-[5px] h-6 bg-purple-500 rounded mr-3"></div>
                    Schedule Information
                  </h3>
                  <div className="grid [grid-template-columns:1fr_1fr] gap-4 p-2">

                  
                    <div className="mb-3">
                      <label>Frequency <span className="text-red-500">*</span></label>
                      <select 
                        name="frequency" 
                        value={configForm.frequency} 
                        onChange={(e) => {
                          handleConfigChange({ target: { name: 'selectedPeriods', value: [] } });
                          handleConfigChange({ target: { name: 'daysOfWeek', value: [] } });
                          handleConfigChange({ target: { name: 'dayOfMonth', value: '' } });
                          handleConfigChange(e);
                        }}
                        className="w-full border rounded p-2" 
                        disabled={disableAllFields}
                      >
                        <option value="">Select Frequency</option>
                        <option value="Daily">Daily</option>
                        <option value="Hourly">Hourly</option>
                        <option value="Weekly">Weekly</option>
                        <option value="Monthly">Monthly</option>
                        <option value="Yearly">Yearly</option>
                        <option value="Half-Yearly">Half-Yearly</option>
                        <option value="Quarterly">Quarterly</option>
                        <option value="Mars Periodic">Mars Periodic</option>
                        <option value="Mars Quarter">Mars Quarter</option>
                        <option value="Mars Year">Mars Year</option>
                        <option value="Mars Half-Yearly">Mars Half-Yearly</option>
                      </select>
                      {formTouched && formErrors.frequency && <div className="text-red-500 text-xs">{formErrors.frequency}</div>}
                    </div>
                    
                    {/* Conditional fields appear right next to frequency */}
                    {configForm.frequency === 'Daily' && (
                      <></>
                    )}
                    
                    {configForm.frequency === 'Weekly' && (
                      <div className="mb-3">
                        <label>Days of Week <span className="text-red-500">*</span></label>
                        <div className="flex flex-wrap gap-2 mt-2">
                          {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((day, index) => (
                            <button
                              key={day}
                              type="button"
                              onClick={() => {
                                const currentDays = configForm.daysOfWeek || [];
                                const isSelected = currentDays.includes(day);
                                const newDays = isSelected 
                                  ? currentDays.filter(d => d !== day)
                                  : [...currentDays, day];
                                handleConfigChange({
                                  target: { name: 'daysOfWeek', value: newDays }
                                });
                              }}
                              className={`px-3 py-1 rounded-full text-sm border ${
                                (configForm.daysOfWeek || []).includes(day)
                                  ? 'bg-purple-500 text-white border-purple-500'
                                  : 'bg-gray-100 text-gray-700 border-gray-300 hover:bg-gray-200'
                              }`}
                              disabled={disableAllFields}
                            >
                              {day}
                            </button>
                          ))}
                        </div>
                        {formTouched && formErrors.daysOfWeek && <div className="text-red-500 text-xs">{formErrors.daysOfWeek}</div>}
                      </div>
                    )}
                    {configForm.frequency === 'Monthly' && (
                      <div className="mb-3">
                        <label>Day of Month (1-31) <span className="text-red-500">*</span></label>
                        <select
                          name="dayOfMonth"
                          value={configForm.dayOfMonth}
                          onChange={handleConfigChange}
                          className="w-full border rounded p-2"
                          disabled={disableAllFields}
                        >
                          <option value="">Select Day</option>
                          {Array.from({ length: 31 }, (_, i) => i + 1).map(day => (
                            <option key={day} value={day}>{day}</option>
                          ))}
                        </select>
                        {formTouched && formErrors.dayOfMonth && <div className="text-red-500 text-xs">{formErrors.dayOfMonth}</div>}
                      </div>
                    )}
                    {configForm.frequency === 'Quarterly' && (
                    <>
                      <div className="mb-3">
                        <label>Select Months (Max 4) <span className="text-red-500">*</span></label>
                        <div className="flex flex-wrap gap-2 mt-2">
                          {['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'].map((month) => (
                            <button key={month} type="button"
                              onClick={() => {
                                const current = configForm.selectedPeriods || [];
                                const monthNum = toMonthNumber(month);
                                const isSelected = current.includes(monthNum);
                                let newPeriods;
                                if (isSelected) { newPeriods = current.filter(p => p !== monthNum); }
                                else if (current.length < 4) { newPeriods = [...current, monthNum]; }
                                else { return; }
                                handleConfigChange({ target: { name: 'selectedPeriods', value: newPeriods } });
                              }}
                              className={`px-3 py-1 rounded-full text-sm border ${
                                (configForm.selectedPeriods || []).includes(toMonthNumber(month))
                                  ? 'bg-purple-500 text-white border-purple-500'
                                  : 'bg-gray-100 text-gray-700 border-gray-300 hover:bg-gray-200'
                              }`}
                              disabled={disableAllFields}>
                              {month}
                            </button>
                          ))}
                        </div>
                          {formTouched && formErrors.selectedPeriods && <div className="text-red-500 text-xs">{formErrors.selectedPeriods}</div>}
                        </div>
                        <div className="mb-3">
                          <label>Day of the selected months (1-31) <span className="text-red-500">*</span></label>
                          <select name="dayOfMonth" value={configForm.dayOfMonth} onChange={handleConfigChange} className="w-full border rounded p-2" disabled={disableAllFields}>
                            <option value="">Select Day</option>
                            {Array.from({ length: 31 }, (_, i) => i + 1).map(day => (
                              <option key={day} value={day}>{day}</option>
                            ))}
                          </select>
                          {formTouched && formErrors.dayOfMonth && <div className="text-red-500 text-xs">{formErrors.dayOfMonth}</div>}
                        </div>
                      </>
                    )}

                    {configForm.frequency === 'Yearly' && (
                    <>
                      <div className="mb-3">
                        <label>Select Month (Max 1) <span className="text-red-500">*</span></label>
                        <div className="flex flex-wrap gap-2 mt-2">
                          {['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'].map((month) => (
                            <button key={month} type="button"
                              onClick={() => {
                                const monthNum = toMonthNumber(month);
                                const isSelected = (configForm.selectedPeriods || []).includes(monthNum);
                                handleConfigChange({ target: { name: 'selectedPeriods', value: isSelected ? [] : [monthNum] } });
                              }}
                              className={`px-3 py-1 rounded-full text-sm border ${
                                (configForm.selectedPeriods || []).includes(toMonthNumber(month))
                                  ? 'bg-purple-500 text-white border-purple-500'
                                  : 'bg-gray-100 text-gray-700 border-gray-300 hover:bg-gray-200'
                              }`}
                              disabled={disableAllFields}>
                              {month}
                            </button>
                          ))}
                        </div>
                          {formTouched && formErrors.selectedPeriods && <div className="text-red-500 text-xs">{formErrors.selectedPeriods}</div>}
                        </div>
                        <div className="mb-3">
                          <label>Day of the selected month (1-31) <span className="text-red-500">*</span></label>
                          <select
                            name="dayOfMonth"
                            value={configForm.dayOfMonth}
                            onChange={handleConfigChange}
                            className="w-full border rounded p-2"
                            disabled={disableAllFields}
                          >
                            <option value="">Select Day</option>
                            {Array.from({ length: 31 }, (_, i) => i + 1).map(day => (
                              <option key={day} value={day}>{day}</option>
                            ))}
                          </select>
                          {formTouched && formErrors.dayOfMonth && <div className="text-red-500 text-xs">{formErrors.dayOfMonth}</div>}
                        </div>
                      </>
                    )}

                    {configForm.frequency === 'Half-Yearly' && (
                    <>
                      <div className="mb-3">
                        <label>Select Months (Max 2) <span className="text-red-500">*</span></label>
                        <div className="flex flex-wrap gap-2 mt-2">
                          {['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'].map((month) => (
                            <button key={month} type="button"
                              onClick={() => {
                                const current = configForm.selectedPeriods || [];
                                const monthNum = toMonthNumber(month);
                                const isSelected = current.includes(monthNum);
                                let newPeriods;
                                if (isSelected) { newPeriods = current.filter(p => p !== monthNum); }
                                else if (current.length < 2) { newPeriods = [...current, monthNum]; }
                                else { return; }
                                handleConfigChange({ target: { name: 'selectedPeriods', value: newPeriods } });
                              }}
                              className={`px-3 py-1 rounded-full text-sm border ${
                                (configForm.selectedPeriods || []).includes(toMonthNumber(month))
                                  ? 'bg-purple-500 text-white border-purple-500'
                                  : 'bg-gray-100 text-gray-700 border-gray-300 hover:bg-gray-200'
                              }`}
                              disabled={disableAllFields}>
                              {month}
                            </button>
                          ))}
                        </div>
                          {formTouched && formErrors.selectedPeriods && <div className="text-red-500 text-xs">{formErrors.selectedPeriods}</div>}
                        </div>
                        <div className="mb-3">
                          <label>Day of the selected months (1-31) <span className="text-red-500">*</span></label>
                          <select
                            name="dayOfMonth"
                            value={configForm.dayOfMonth}
                            onChange={handleConfigChange}
                            className="w-full border rounded p-2"
                            disabled={disableAllFields}
                          >
                            <option value="">Select Day</option>
                            {Array.from({ length: 31 }, (_, i) => i + 1).map(day => (
                              <option key={day} value={day}>{day}</option>
                            ))}
                          </select>
                          {formTouched && formErrors.dayOfMonth && <div className="text-red-500 text-xs">{formErrors.dayOfMonth}</div>}
                        </div>
                      </>
                    )}
                    
                    {configForm.frequency === 'Mars Periodic' && (
                      <div className="mb-3">
                        <label>Days (1-28) <span className="text-red-500">*</span></label>
                        <select 
                          name="dayOfMonth" 
                          value={configForm.dayOfMonth} 
                          onChange={handleConfigChange} 
                          className="w-full border rounded p-2" 
                          disabled={disableAllFields}
                        >
                          <option value="">Select Day</option>
                          {Array.from({ length: 28 }, (_, i) => i + 1).map(day => (
                            <option key={day} value={day}>{day}</option>
                          ))}
                        </select>
                        {formTouched && formErrors.dayOfMonth && <div className="text-red-500 text-xs">{formErrors.dayOfMonth}</div>}
                      </div>
                    )}
                    
                    {configForm.frequency === 'Mars Quarter' && (
                      <>
                        <div className="mb-3">
                          <label>Select Periods (Max 4) <span className="text-red-500">*</span></label>
                          <div className="flex flex-wrap gap-2 mt-2">
                            {Array.from({ length: 13 }, (_, i) => `P${i + 1}`).map((period) => (
                              <button
                                key={period}
                                type="button"
                                onClick={() => {
                                  const currentPeriods = configForm.selectedPeriods || [];
                                  const isSelected = currentPeriods.includes(period);
                                  let newPeriods;
                                  if (isSelected) {
                                    newPeriods = currentPeriods.filter(p => p !== period);
                                  } else if (currentPeriods.length < 4) {
                                    newPeriods = [...currentPeriods, period];
                                  } else {
                                    return; // Don't allow more than 4 selections
                                  }
                                  handleConfigChange({
                                    target: { name: 'selectedPeriods', value: newPeriods }
                                  });
                                }}
                                className={`px-3 py-1 rounded-full text-sm border ${
                                  (configForm.selectedPeriods || []).includes(period)
                                    ? 'bg-purple-500 text-white border-purple-500'
                                    : 'bg-gray-100 text-gray-700 border-gray-300 hover:bg-gray-200'
                                }`}
                                disabled={disableAllFields}
                              >
                                {period}
                              </button>
                            ))}
                          </div>
                          {formTouched && formErrors.selectedPeriods && <div className="text-red-500 text-xs">{formErrors.selectedPeriods}</div>}
                        </div>
                        <div className="mb-3">
                          <label>Which day of the above period selected? (1-28) <span className="text-red-500">*</span></label>
                          <select 
                            name="dayOfMonth" 
                            value={configForm.dayOfMonth} 
                            onChange={handleConfigChange} 
                            className="w-full border rounded p-2" 
                            disabled={disableAllFields}
                          >
                            <option value="">Select Day</option>
                            {Array.from({ length: 28 }, (_, i) => i + 1).map(day => (
                              <option key={day} value={day}>{day}</option>
                            ))}
                          </select>
                          {formTouched && formErrors.dayOfMonth && <div className="text-red-500 text-xs">{formErrors.dayOfMonth}</div>}
                        </div>
                      </>
                    )}
                    
                    {configForm.frequency === 'Mars Year' && (
                      <>
                        <div className="mb-3">
                          <label>Select Period (Max 1) <span className="text-red-500">*</span></label>
                          <div className="flex flex-wrap gap-2 mt-2">
                            {Array.from({ length: 13 }, (_, i) => `P${i + 1}`).map((period) => (
                              <button
                                key={period}
                                type="button"
                                onClick={() => {
                                  const currentPeriods = configForm.selectedPeriods || [];
                                  const isSelected = currentPeriods.includes(period);
                                  let newPeriods;
                                  if (isSelected) {
                                    newPeriods = [];
                                  } else {
                                    newPeriods = [period]; // Only allow one selection
                                  }
                                  handleConfigChange({
                                    target: { name: 'selectedPeriods', value: newPeriods }
                                  });
                                }}
                                className={`px-3 py-1 rounded-full text-sm border ${
                                  (configForm.selectedPeriods || []).includes(period)
                                    ? 'bg-purple-500 text-white border-purple-500'
                                    : 'bg-gray-100 text-gray-700 border-gray-300 hover:bg-gray-200'
                                }`}
                                disabled={disableAllFields}
                              >
                                {period}
                              </button>
                            ))}
                          </div>
                          {formTouched && formErrors.selectedPeriods && <div className="text-red-500 text-xs">{formErrors.selectedPeriods}</div>}
                        </div>
                        <div className="mb-3">
                          <label>Which day of the above period selected? (1-28) <span className="text-red-500">*</span></label>
                          <select 
                            name="dayOfMonth" 
                            value={configForm.dayOfMonth} 
                            onChange={handleConfigChange} 
                            className="w-full border rounded p-2" 
                            disabled={disableAllFields}
                          >
                            <option value="">Select Day</option>
                            {Array.from({ length: 28 }, (_, i) => i + 1).map(day => (
                              <option key={day} value={day}>{day}</option>
                            ))}
                          </select>
                          {formTouched && formErrors.dayOfMonth && <div className="text-red-500 text-xs">{formErrors.dayOfMonth}</div>}
                        </div>
                      </>
                    )}
                    
                    {configForm.frequency === 'Mars Half-Yearly' && (
                      <>
                        <div className="mb-3">
                          <label>Select Periods (Max 2) <span className="text-red-500">*</span></label>
                          <div className="flex flex-wrap gap-2 mt-2">
                            {Array.from({ length: 13 }, (_, i) => `P${i + 1}`).map((period) => (
                              <button
                                key={period}
                                type="button"
                                onClick={() => {
                                  const currentPeriods = configForm.selectedPeriods || [];
                                  const isSelected = currentPeriods.includes(period);
                                  let newPeriods;
                                  if (isSelected) {
                                    newPeriods = currentPeriods.filter(p => p !== period);
                                  } else if (currentPeriods.length < 2) {
                                    newPeriods = [...currentPeriods, period];
                                  } else {
                                    return; // Don't allow more than 2 selections
                                  }
                                  handleConfigChange({
                                    target: { name: 'selectedPeriods', value: newPeriods }
                                  });
                                }}
                                className={`px-3 py-1 rounded-full text-sm border ${
                                  (configForm.selectedPeriods || []).includes(period)
                                    ? 'bg-purple-500 text-white border-purple-500'
                                    : 'bg-gray-100 text-gray-700 border-gray-300 hover:bg-gray-200'
                                }`}
                                disabled={disableAllFields}
                              >
                                {period}
                              </button>
                            ))}
                          </div>
                          {formTouched && formErrors.selectedPeriods && <div className="text-red-500 text-xs">{formErrors.selectedPeriods}</div>}
                        </div>
                        <div className="mb-3">
                          <label>Which day of the above period selected? (1-28) <span className="text-red-500">*</span></label>
                          <select 
                            name="dayOfMonth" 
                            value={configForm.dayOfMonth} 
                            onChange={handleConfigChange} 
                            className="w-full border rounded p-2" 
                            disabled={disableAllFields}
                          >
                            <option value="">Select Day</option>
                            {Array.from({ length: 28 }, (_, i) => i + 1).map(day => (
                              <option key={day} value={day}>{day}</option>
                            ))}
                          </select>
                          {formTouched && formErrors.dayOfMonth && <div className="text-red-500 text-xs">{formErrors.dayOfMonth}</div>}
                        </div>
                      </>
                    )}
                    
                    {/* Generic Time field for all non-Hourly frequencies */}
                    {configForm.frequency && configForm.frequency !== 'Hourly' && (
                      <div className="mb-3">
                        <label>Time <span className="text-red-500">*</span></label>
                        <div className="flex items-center gap-2">
                          <input 
                            type="time"
                            name="time" 
                            value={configForm.time} 
                            onChange={handleConfigChange} 
                            className="flex-1 border rounded p-2" 
                            disabled={disableAllFields} 
                          />
                          <span className="px-3 py-2 bg-gray-100 border border-gray-300 rounded text-sm font-medium text-gray-700">
                            UTC
                          </span>
                        </div>
                        {formTouched && formErrors.time && <div className="text-red-500 text-xs">{formErrors.time}</div>}
                      </div>
                    )}
                    
                   
                  </div>
                </div>

                {/* Asset - Dimension Threshold Information Section */}
                <div className="mb-6 bg-orange-50 rounded-lg p-4 border border-orange-200">
                  <h3 className="text-lg font-semibold text-orange-800 mb-4 flex items-center">
                    <div className="w-[5px] h-6 bg-orange-500 rounded mr-3"></div>
                    Asset - Dimension Threshold Information
                  </h3>
                  <div className="grid [grid-template-columns:1fr_1fr] gap-4 p-2">
                    <div className="mb-3">
                      <label>Completeness % <span className="text-red-500">*</span></label>
                      <input 
                        name="completeness" 
                        type="number" 
                        value={configForm.completeness} 
                        onChange={handleConfigChange} 
                        placeholder="Enter value (min 0, max 100)"
                        className="w-full border rounded p-2" 
                        min="0" 
                        max="100" 
                        disabled={disableAllFields} 
                      />
                      {formTouched && formErrors.completeness && <div className="text-red-500 text-xs">{formErrors.completeness}</div>}
                    </div>
                    <div className="mb-3">
                      <label>Uniqueness % <span className="text-red-500">*</span></label>
                      <input 
                        name="uniqueness" 
                        type="number" 
                        value={configForm.uniqueness} 
                        onChange={handleConfigChange} 
                        placeholder="Enter value (min 0, max 100)"
                        className="w-full border rounded p-2" 
                        min="0" 
                        max="100" 
                        disabled={disableAllFields} 
                      />
                      {formTouched && formErrors.uniqueness && <div className="text-red-500 text-xs">{formErrors.uniqueness}</div>}
                    </div>
                    <div className="mb-3">
                      <label>Validity % <span className="text-red-500">*</span></label>
                      <input 
                        name="validity" 
                        type="number" 
                        value={configForm.validity} 
                        onChange={handleConfigChange} 
                        placeholder="Enter value (min 0, max 100)"
                        className="w-full border rounded p-2" 
                        min="0" 
                        max="100" 
                        disabled={disableAllFields} 
                      />
                      {formTouched && formErrors.validity && <div className="text-red-500 text-xs">{formErrors.validity}</div>}
                    </div>
                    <div className="mb-3">
                      <label>Accuracy % <span className="text-red-500">*</span></label>
                      <input 
                        name="accuracy" 
                        type="number" 
                        value={configForm.accuracy} 
                        onChange={handleConfigChange} 
                        placeholder="Enter value (min 0, max 100)"
                        className="w-full border rounded p-2" 
                        min="0" 
                        max="100" 
                        disabled={disableAllFields} 
                      />
                      {formTouched && formErrors.accuracy && <div className="text-red-500 text-xs">{formErrors.accuracy}</div>}
                    </div>
                    <div className="mb-3">
                      <label>Consistency % <span className="text-red-500">*</span></label>
                      <input 
                        name="consistency" 
                        type="number" 
                        value={configForm.consistency} 
                        onChange={handleConfigChange} 
                        placeholder="Enter value (min 0, max 100)"
                        className="w-full border rounded p-2" 
                        min="0" 
                        max="100" 
                        disabled={disableAllFields} 
                      />
                      {formTouched && formErrors.consistency && <div className="text-red-500 text-xs">{formErrors.consistency}</div>}
                    </div>
                    <div className="mb-3">
                      <label>How much % of data - do you wish to profile in the next step? <span className="text-red-500">*</span></label>
                      <input 
                        name="sampleSize" 
                        type="number" 
                        value={configForm.sampleSize} 
                        onChange={handleConfigChange} 
                        placeholder="Enter value (min 0, max 100)"
                        className="w-full border rounded p-2" 
                        min="0" 
                        max="100" 
                        disabled={disableAllFields} 
                      />
                      {formTouched && formErrors.sampleSize && <div className="text-red-500 text-xs">{formErrors.sampleSize}</div>}
                    </div>
                    <div className="mb-3">
                      <label>Freshness % <span className="text-red-500">*</span></label>
                      <input 
                        name="freshness" 
                        type="number" 
                        value={configForm.freshness} 
                        onChange={handleConfigChange} 
                        placeholder="Enter value (min 0, max 100)"
                        className="w-full border rounded p-2" 
                        min="0" 
                        max="100" 
                        disabled={disableAllFields} 
                      />
                      {formTouched && formErrors.freshness && <div className="text-red-500 text-xs">{formErrors.freshness}</div>}
                    </div>
                  </div>
                </div>

                {/* Data Asset Job Selection Section */}
                <div className="mb-6 bg-green-50 rounded-lg p-4 border border-green-200">
                  <h3 className="text-lg font-semibold text-green-800 mb-4 flex items-center">
                    <div className="w-[5px] h-6 bg-green-500 rounded mr-3"></div>
                    Data Quality Job Selection
                  </h3>

                  <div className="flex items-center gap-4 mb-4">
                    <span className={`text-sm font-medium ${!isAtRest ? 'text-green-700' : 'text-gray-500'}`}>
                      In Motion
                    </span>
                    <button
                      type="button"
                      onClick={() => {
                        if (isAtRest) {
                          handleConfigChange({ target: { name: 'workSpaceDevUrl', value: '' } });
                          handleConfigChange({ target: { name: 'workSpaceProdUrl', value: '' } });
                          handleConfigChange({ target: { name: 'dataAssetJobType', value: 'in_motion' } });
                        } else {
                          handleConfigChange({ target: { name: 'dataAssetJobType', value: 'at_rest' } });
                        }
                      }}
                      disabled={disableAllFields}
                      className={`relative inline-flex h-[24px] w-[48px] items-center rounded-full transition-colors duration-200 focus:outline-none ${
                        isAtRest ? 'bg-green-500' : 'bg-gray-300'
                      } ${disableAllFields ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
                    >
                      <span
                        className={`inline-block h-[16px] w-[16px] transform rounded-full bg-white shadow transition-transform duration-200 ${
                          isAtRest ? 'translate-x-[28px]' : 'translate-x-[4px]'
                        }`}
                      />
                    </button>
                    <span className={`text-sm font-medium ${isAtRest ? 'text-green-700' : 'text-gray-500'}`}>
                      At Rest
                    </span>
                  </div>

                  {isAtRest && (
                     <>
                    <div className="grid [grid-template-columns:1fr_1fr] gap-4 p-2">
                      <div className="mb-3">
                        <label>Workspace URL (Dev)</label>
                        <input
                          name="workSpaceDevUrl"
                          value={configForm.workSpaceDevUrl}
                          onChange={handleConfigChange}
                          placeholder="https://adb-xxxx.azuredatabricks.net/jobs/xxxx"
                          className="w-full border rounded p-2"
                          disabled={disableAllFields}
                        />
                        {formTouched && formErrors.workSpaceDevUrl && (
                          <div className="text-red-500 text-xs">{formErrors.workSpaceDevUrl}</div>
                        )}
                      </div>
                      <div className="mb-3">
                        <label>Workspace URL (Prod)</label>
                        <input
                          name="workSpaceProdUrl"
                          value={configForm.workSpaceProdUrl}
                          onChange={handleConfigChange}
                          placeholder="https://adb-xxxx.azuredatabricks.net/jobs/xxxx"
                          className="w-full border rounded p-2"
                          disabled={disableAllFields}
                        />
                        {formTouched && formErrors.workSpaceProdUrl && (
                          <div className="text-red-500 text-xs">{formErrors.workSpaceProdUrl}</div>
                        )}
                      </div>
                    </div>
                     <div className="flex items-start gap-2 mt-2 px-3 py-2 bg-blue-50 border border-blue-200 rounded-lg">
                        <TriangleAlert size={14} className=' text-blue-700' />
                        <p className="text-sm text-blue-700 font-medium">
                          If Prod and Dev workspace URLs are not provided, the application will use the default URLs.
                        </p>
                      </div>
                    </>
                  )}
                </div>
                  
                  <div className="flex justify-end gap-2 mt-4">
                    <button type="button" onClick={closeConfigModal} className="px-4 py-2 bg-gray-200 rounded" >Cancel</button>
                    <button
                      type="button"
                      onClick={handleConfigSave}
                      className={`px-4 py-2 rounded ${disableAllFields || !allFieldsValid ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-[#bb1ccc] text-white'}`}
                      disabled={disableAllFields || !allFieldsValid}
                    >
                      Save
                    </button>
                  </div>
                  
                </form>
              </Box>
            </Dialog> 
        </>
    )
}

export default ConfigPopup;